module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAMAAAANIilAAAAAQlBMVEUAAABgboNeboNgb4NeboJfboJgb4RfboJfboNebYJgboRgbYJfboJeb4NhboRebYNfb4Nhb4ZkdINjc4xfboNebYJCqt9wAAAAFXRSTlMAgKJz79U//efFRYW6Z0+oWTchD4Sk+OVsAAAA1ElEQVRIx+3U2Q6CMBCF4bH7wo59/1fVkJAxqWB76pXy338BpmWIaOhcqs51Az0TCUwQ9QmuJ49jTwrHqunJTd/cNO2Wc/7FTBQiGogGnbZ0qLfS7oO1stbe0ks3xLJGLGvEskYsa8SyRixrxLJGLGvEskYsa8SyPrGwlqko+c4GW4ZtoDydCtO5Nak4k+F7OY4ZFuVYfBdH+LXxgeFHhV8S/HrmTeozVRMdtEqvTqWXa8USzX/CC1/4v7HcsQSw4ZUFpPeVhTSrbQHMBLWMzo0LHfcAR0V+nHFiI9gAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/backtop/top.png
// module id = 6
// module chunks = 0